// extracted by mini-css-extract-plugin
module.exports = {"Checked":"PlatformFavorite_Checked__hrk2d","Compact":"PlatformFavorite_Compact__OcE_7","Unchecked":"PlatformFavorite_Unchecked__3AekM","Expand":"PlatformFavorite_Expand__Et9sX"};